import { styled } from '@cherre-frontend/ui';

export const DestinationEditConfigurationTablesSkeletonsContainer = styled(
  'div'
)`
  border-radius: 5px;
  background: #eee;
  padding: 30px;
  width: 100%;
`;
